import { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import { ICartEntry } from '@rbi-ctg/menu';
import { useLoyaltyContext } from 'state/loyalty';
import { useOffersContext } from 'state/offers';
import { useOrderContext } from 'state/order';

export const useCartItemEditingTools = ({
  item,
  isOffer,
}: {
  item: ICartEntry;
  isOffer?: boolean;
}) => {
  const { removeFromCart, updateQuantity } = useOrderContext();
  const { clearSelectedOffer } = useOffersContext();
  const navigate = useNavigate();
  const { loyaltyEnabled, unApplyReward, appliedLoyaltyRewards } = useLoyaltyContext();

  const handleEditItem = useCallback(() => {
    navigate(item.url);
  }, [item.url, navigate]);

  const handleRemoveItem = useCallback(() => {
    isOffer ? clearSelectedOffer() : removeFromCart(item.cartId);
  }, [clearSelectedOffer, isOffer, item.cartId, removeFromCart]);

  const handleQuantityChange = useCallback(
    (quantity: number) => {
      if (loyaltyEnabled) {
        const numberOfAppliedRewards = appliedLoyaltyRewards[item.cartId]?.timesApplied;
        const quantityLessThanAppliedRewards = quantity < numberOfAppliedRewards;
        if (quantityLessThanAppliedRewards) {
          unApplyReward({
            rewardBenefitId: item._id,
            cartId: item.cartId,
          });
        }
      }

      updateQuantity(item.cartId, quantity);
    },
    [appliedLoyaltyRewards, item._id, item.cartId, loyaltyEnabled, unApplyReward, updateQuantity]
  );

  return {
    handleEditItem,
    handleRemoveItem,
    handleQuantityChange,
  };
};
